import React, { useEffect, useState } from 'react';
import { Link, useParams, useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { FaEdit } from 'react-icons/fa';
import Modal from 'react-bootstrap/Modal';
import { Loading } from '~/components';
import { showRecurso } from '~/store/modules/recurso/action';

const List = () => {
  let history = useHistory();
  const dispatch = useDispatch();
  const { recurso_id } = useParams();
  const [recursoShow, setRecursoShow] = useState({});

  const { recurso } = useSelector(({ RecursoReducer }) => RecursoReducer);

  useEffect(() => {
    dispatch(showRecurso(recurso_id));
  }, [dispatch, recurso_id]);
  useEffect(() => {
    if (recurso.id === parseInt(recurso_id)) {
      setRecursoShow(recurso);
    }
  }, [recurso, recurso_id]);




  const handleClose = () => {
    history.push('/recurso');
  };

  return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      dialogClassName="modal-xl"
      onHide={handleClose}
      show
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Recurso</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="card">
          <div className="card-header">
            <h2 className="card-title">Detalhes</h2>
            <div className="card-tools">
              <Link
                className="btn btn-default"
                to={{
                  pathname: `/recurso/${recurso.id}/edit`,
                  state: { modal: true },
                }}
              >
                <FaEdit /> Editar
              </Link>
            </div>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              {recursoShow.id === parseInt(recurso_id) ? (
                <table className="table table-hover table-striped">
                  <tbody>
                    <tr>
                      <th>id</th>
                      <td>{recurso.id}</td>
                    </tr>
                    <tr>
                      <th>Nome</th>
                      <td>{recurso.nome}</td>
                    </tr>
                    <tr>
                      <th>Rota</th>
                      <td>{recurso.nome_rota}</td>
                    </tr>
                  </tbody>
                </table>
              ) : (
                <Loading />
              )}
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Link className="btn btn-default" to="/recurso">
          <i className="fa fa-window-close" /> Fechar
        </Link>
      </Modal.Footer>
    </Modal>
  );
};

export default List;
